import styled, { css } from "styled-components";


export const CloseButtonWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: right;
	z-index: 0;
`;

export const FilterCloseButton = styled.button`
	z-index: 9999;
`;

export const FilterRows = styled.div``;

export const FilterColumn = styled.div`
	margin-bottom: 20px;
`;


export const FilterWrapperButtons = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	font-size: 14px;
	font-weight: 500;
	line-height: 32px;
	margin-top: 20px;
`;
export const FilterGoFilterButton = styled.button`
	width: 78px;
	height: 44px;
	padding: 8px 20px;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center !important;
	${(props) =>
		props.isDisable
			? css`
					background-color: var(--Gray-20, #f0f0f3) !important;
					color: var(--Gray-100, #b5b5c3);
			  `
			: css`
					background-color: rgba(37, 85, 239, 1) !important;
					color: var(--White, var(--White-100, #fff));

					&:hover {
						background-color: #214dd7 !important;
					}
			  `}
`;
export const FilterClearButton = styled.button`
	width: 78px;
	height: 44px;
	padding: 8px 20px;
	border-radius: 5px;
	margin-right: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${(props) =>
		props.isDisable ? "var(--Gray-10, #F8F8F9) !important" : " rgba(37, 85, 239, 0.08) !important"};

	${(props) =>
		props.isDisable
			? css`
					background-color: var(--Gray-10, #f8f8f9) !important;
					color: var(--Gray-100, #b5b5c3);
			  `
			: css`
					background-color: rgba(37, 85, 239, 0.08) !important;
					color: #2555ef;
					&:hover {
						background: rgba(37, 85, 239, 0.2) !important;
					}
			  `}
`;

export const DonationAmountRange = styled.div`

`